import React, { useEffect, useState, useContext } from 'react';
import {
  Box,
  Button,
  Typography,
  Grid,
  AppBar,
  Toolbar,
  ListItemAvatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FirebaseAuth } from '../../utils/firebase/firebase';
import { sendEmailVerification } from 'firebase/auth';
import AuthContext from '../../contexts/AuthContext';
import LogoWhite from '../../assets/images/LogoWhite.png';
import Email from '../../assets/images/Email.png';

const EmailVerificationNote = ({ setUser }) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');

  useEffect(() => {
    if (user && user.emailVerified) {
      setUser(user);
      navigate('/');
    }
  }, [user, navigate, setUser]);
  const handleResendVerification = async () => {
    const currentUser = FirebaseAuth?.currentUser;
    if (currentUser && !currentUser?.emailVerified) {
      try {
        await sendEmailVerification(currentUser);
        setDialogMessage('Verification email sent again!');
        setOpenDialog(true);
      } catch (error) {
        if (error.code === 'auth/too-many-requests') {
          setDialogMessage(
            'Too many attempts. Please wait a while before trying again.'
          );
        } else {
          setDialogMessage('An error occurred. Please try again later.');
        }
        setOpenDialog(true);
      }
    }
  };

  return (
    <>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle
          sx={{ backgroundColor: 'var(--clr-mindly-purple)', color: 'white' }}
        >
          Notice
        </DialogTitle>
        <DialogContent sx={{ marginTop: '10px' }}>
          <Typography>{dialogMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Grid
        container
        direction='column'
        sx={{
          minHeight: '100vh',
          minWidth: '100vw',
          backgroundColor: '#e4eef0',
        }}
      >
        <Grid item>
          <AppBar position='static' sx={{ bgcolor: 'var(--clr-theme-purple)' }}>
            <Toolbar>
              <ListItemAvatar sx={{ cursor: 'pointer' }}>
                <img src={LogoWhite} alt='Logo' height='50px' />
              </ListItemAvatar>
              <Typography
                variant='h6'
                noWrap
                sx={{
                  letterSpacing: '.1rem',
                  color: 'inherit',
                  fontSize: { xs: '20px !important', md: '24px !important' },
                  fontWeight: 'bold',
                }}
                className='brand'
              >
                Mindly
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
            </Toolbar>
          </AppBar>
        </Grid>

        <Grid
          item
          container
          direction='column'
          alignItems='center'
          justifyContent='center'
          sx={{ flexGrow: 1 }}
        >
          <Box
            sx={{
              textAlign: 'center',
              width: { xs: '90%', sm: '70%', md: '50%', lg: '40%' },
              backgroundColor: 'white',
              boxShadow: '0 0 5px var(--clr-theme-purple)',
              borderRadius: 2,
              p: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Typography
              variant='h4'
              sx={{
                fontFamily: 'Lato',
                fontWeight: 400,
                mb: 2,
                fontSize: { xs: '1.5rem', md: '2rem' },
              }}
            >
              Please verify your email
            </Typography>
            <Typography
              variant='subtitle1'
              sx={{
                color: 'var(--clr-theme-gray)',
                fontFamily: 'Lato',
                fontWeight: 1000,
                mb: 2,
              }}
            >
              Check your email & click the link to proceed to Mindly
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'ceneter',
                alignItems: 'center',
              }}
            >
              <img
                src={Email}
                alt='Email'
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  marginBottom: '1rem',
                }}
              />

              <Button
                onClick={handleResendVerification}
                variant='contained'
                color='success'
                sx={{
                  background: '#9291f0',
                  textTransform: 'capitalize',
                  width: { xs: '80px', sm: '100px' },
                  mb: 3,
                }}
              >
                Resend
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default EmailVerificationNote;
